// ── the viewer's netti, where the share card can reach it ────────────────────
//
// The share card's host is mounted beside the shell, not inside it, so the
// shell's context (useOsShell().netti) does not reach it. Anything inside the
// shell that holds the viewer's netti publishes it here (useShareCard does, and
// the shell may), and the studio reads it. It holds ONE value — the netti the
// dashboard is drawing right now — never a derived or a guessed one
// (law_one_netti): when nothing has published, the card goes without a creature.
//
// A tiny external store (subscribe · get · publish), shaped for
// useSyncExternalStore. Pure and client-safe; nothing here leaves the page.

import type { ShareNetti } from './types';

let current: ShareNetti | null = null;
const subs = new Set<() => void>();

/** the same netti, so a re-publish of an equal value wakes nobody */
export function sameNetti(a: ShareNetti | null, b: ShareNetti | null): boolean {
  if (a === b) return true;
  if (!a || !b) return false;
  return (
    a.seed === b.seed &&
    a.age === b.age &&
    a.ground[0] === b.ground[0] &&
    a.ground[1] === b.ground[1] &&
    a.ground[2] === b.ground[2] &&
    JSON.stringify(a.color) === JSON.stringify(b.color) &&
    JSON.stringify(a.body ?? null) === JSON.stringify(b.body ?? null)
  );
}

/** hand the store the netti the shell is drawing (null when it leaves) */
export function publishShareNetti(n: ShareNetti | null): void {
  if (sameNetti(current, n)) return;
  current = n;
  for (const fn of subs) fn();
}

export function getShareNetti(): ShareNetti | null {
  return current;
}

export function subscribeShareNetti(fn: () => void): () => void {
  subs.add(fn);
  return () => {
    subs.delete(fn);
  };
}
